"use client";

import {useOrg} from "@/hooks/useOrg";
import {apiLive} from "@/lib/api";
import type {ToolHttpPayload} from "@/types/tools";
import {GAIL_API} from "@/utils/common/constants/routes";
import {createSharedApprovalLookup} from "./createSharedApprovalLookup";

const EMPTY: ReadonlyMap<string, string> = new Map();
const useNames = createSharedApprovalLookup(async (_orgId: string) => {
   const tools = await apiLive<ToolHttpPayload[]>(`${GAIL_API}/.internal/http_tools`, undefined, undefined, undefined, true);
   if (!tools) throw new Error("Failed to load tool names");
   return new Map(tools.filter(tool => tool.id && tool.name?.trim()).map(tool => [tool.id!, tool.name]));
});

/** Display-only labels, shared across mounted approvals and scoped to the organization. */
export function useToolNames(enabled: boolean): ReadonlyMap<string, string> {
   const {org} = useOrg();
   return useNames(enabled && org?.id ? org.id : null) ?? EMPTY;
}
